import React from 'react';
import { StyledPostList } from './PostList.style';

const PostList = (props) => {
  return <StyledPostList {...props}>{props.children}</StyledPostList>;
};

export default PostList;
